<template>
	<li :class="$style['app-aside-nav__item']">
		<a
			v-testid="'nav-item-recar-lite'"
			:href="href"
			target="_blank"
			:class="[
				$style['app-aside-nav__link']
			]"
		>
			<BaseIconButton
				:class="$style['app-aside-nav__link-icon']"
			>
				<img
					style="width: 100%;"
					:withRipple="false"
					:src="image"
					:alt="`${title}-img`"
				/>
			</BaseIconButton>
			{{ title }}
		</a>
	</li>
</template>
<script>
import pluralize from 'pluralize'
export default {
	name: 'AppAsideExternalLink',
	props: {
		href: {
			type: String,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		image: {
			type: String,
			default: null
		}
	},
	computed: {
		isActive () {
			return this.$route.matched.some(route => route.name ? this.route.name.includes(route.name) || this.route.name.includes(pluralize(route.name)) : false)
		},
		icon () {
			if (this.isActive) {
				return this.route.meta.activeIcon.split(' ')
			}
			return this.route.meta.icon.split(' ')
		}
	}
}
</script>
<style lang="scss" module>
    .app-aside-nav {
        &__item {
            // flex: 1;
        }

        &__link {
            display: flex;
            align-items: center;
            padding: $gutter ($gutter * 2) - 2;
            margin: 0;
            text-decoration: none;
            color: getColor(sub-text);
            font-size: 14px;
            border-left: 2px solid transparent;
            transition: background-color 0.2s ease, border-left 0.2s ease,
            padding 0.2s ease;
            width: 100%;
            justify-content: flex-start;
            white-space: nowrap;

            &:hover {
                background-color: getColor(hover-overlay);
                transition: 0.2s ease;
            }

            &-icon {
                margin-right: $gutter * 2.25 !important;

                &::before {
                    content: none !important;
                    height: 0;
                    width: 0;
                    background-color: transparent;
                    position: absolute;
                    border-radius: 100%;
                    z-index: -1;
                    transition: 0.2s ease;
                }
            }

            &--open {
                // Open state
            }

            &--active {
                color: getColor(primary);
                border-right: 2px solid getColor(primary);
            }
        }
    }
</style>
